const robots = [
    {
      id: 1,
      name: 'Faran Mohammad',
      username: 'faran._.heit',
      email: 'ffaranm15@gmail.com'
    },
    {
      id: 2,
      name: 'Sidra Rizwan',
      username: 'sidrar',
      email: 'sidrar2408@gmail.com'
    },
    {
      id: 3,
      name: 'Fariha Fatima',
      username: 'farihaf',
      email: 'farihaf@iul.ac.in'
    },
    {
      id: 4,
      name: 'Subhana Fatima',
      username: 'subhanaf',
      email: 'subhanaf@iul.ac.in'
    },
    {
      id: 5,
      name: 'Abid Rahman',
      username: 'chunna',
      email: 'arabid@gmail.com'
    },
    {
      id: 6,
      name: 'Hera Fatima',
      username: 'hera',
      email: 'iamfatimasiddiqui@gmail.com'
    },
    {
      id: 7,
      name: 'Farheen Husain',
      username: 'farheenify',
      email: 'farheenhu@gmail.com'
    },
    {
      id: 8,
      name: 'Sakshi Panday',
      username: 'taku',
      email: 'sakship@gmail.com'
    },
    {
      id: 9,
      name: 'Fazal Mahmood',
      username: 'fazal',
      email: 'ifazalmahmood@gmail.com'
    },
    {
      id: 10,
      name: 'Deepak Shakya',
      username: 'deepakshakya',
      email: 'deepak@gmail.com'
    },
    {
      id: 11,
      name: 'Amber Jalil',
      username: 'painaj',
      email: 'painaj@gmail.com'
    },
    {
      id: 12,
      name: 'Sakina Mehdi',
      username: 'sakina',
      email: 'zoyam@gmail.com'
    }
  ];
  module.exports={robots}